import { Routes, Route } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { Floater } from 'components'

// 메인
import Home from './home'
import EditLayer from './EditLayer'

// 데일리리포트
import ReportIntro from './ReportIntro'
import Report from './Report'

// 금융인플루언서
import InfluencerIntro from './InfluencerIntro'
import Influencer from './Influencer'
import InfluencerProfile from './InfluencerProfile'
import ProfileModify from './ProfileModify'
import Participate from './Participate'
import ParticipateStop from './ParticipateStop'
import InfluencerMy from './InfluencerMy'
import InfluencerDetail from './InfluencerDetail'
import InfluencerResign from './InfluencerResign'
import InfluencerOthers from './InfluencerOthers'
import InfluencerOthersDetail from './InfluencerOthersDetail'

// 데이터증명서
import DataIntro from './DataIntro'
import DataList from './DataList'
import DataSelect from './DataSelect'
import DataDetail from './DataDetail'
import DataDetailOthers from './DataDetailOthers'
import DataPwSetting from './DataPwSetting'
import DataPw from './DataPw'
import DataPwTimeOut from './DataPwTimeOut'
import DataPwError from './DataPwError'

// 차량조회
import CarIntro from './CarIntro'
import Car from './Car'
import CarMy from './CarMy'
import CarDetail1 from './CarDetail1'
import CarDetail2 from './CarDetail2'
import CarRepair from './CarRepair'
import CarAccident from './CarAccident'

import NotFound from 'views/NotFound'
import Main from 'views/main/home'
import DataNoneIntro from 'views/mydata/DataNoneIntro'

// home
const Index = () => {

	return (
		<>
			<Floater>
				<li><Link to="">메인</Link></li>
				<li><Link to="layer">메뉴 편집 레이어</Link></li>
				<li><Link to="reportIntro">데일리리포트 (데이터 미 연결시)</Link></li>
				<li><Link to="report">데일리리포트 (데이터 연결 시)</Link></li>
				<li><Link to="influencerIntro">인플루언서 튜토리얼</Link></li>
				<li><Link to="influencer">인플루언서 목록 (미참여)</Link></li>
				<li><Link to="influencerProfile">인플루언서 프로필 입력</Link></li>
				<li><Link to="profileModify">인플루언서 프로필 수정</Link></li>
				<li><Link to="participate">인플루언서 참여</Link></li>
				<li><Link to="participateStop">인플루언서 정지계정</Link></li>
				<li><Link to="influencerMy">인플루언서 홈 MY</Link></li>
				<li><Link to="influencerDetail">인플루언서 상세</Link></li>
				<li><Link to="influencerResign">인플루언서 철회</Link></li>
				<li><Link to="InfluencerOthers">인플루언서 홈 타인</Link></li>
				<li><Link to="InfluencerOthersDetail">인플루언서 타인 상세</Link></li>
				<li><Link to="dataIntro">데이터증명서 인트로</Link></li>
				<li><Link to="dataList">데이터증명서 목록</Link></li>
				<li><Link to="dataSelect">공유데이터 선택</Link></li>
				<li><Link to="dataDetail">증명서 공유하기 데이터 상세</Link></li>
				<li><Link to="dataDetailOthers">데이터 상세 타인</Link></li>
				<li><Link to="dataPwSetting">데이터증명서 비밀번호 설정</Link></li>
				<li><Link to="dataPw">데이터증명서 비밀번호 입력</Link></li>
				<li><Link to="dataPwTimeOut">데이터증명서 비밀번호 시간초과</Link></li>
				<li><Link to="dataPwError">데이터증명서 비밀번호 에러</Link></li>
				<li><Link to="carIntro">차량조회 인트로</Link></li>
				<li><Link to="car">차량조회</Link></li>
				<li><Link to="carMy">차량조회 결과</Link></li>
				<li><Link to="carDetail1">차량조회 차량 상세1</Link></li>
				<li><Link to="carDetail2">차량조회 차량 상세2</Link></li>
				<li><Link to="carRepair">차량조회 수리 정비 내역</Link></li>
				<li><Link to="carAccident">차량조회 사고이력</Link></li>
			</Floater>
			<Routes>
				<Route path="/layer" element={<EditLayer />} /> { /* 메뉴 편집 레이어 */}
				<Route path="/reportIntro" element={<ReportIntro />} /> { /* 데일리리포트 (데이터 미 연결시) */}
				<Route path="/report" element={<Report />} /> { /* 데일리리포트 (데이터 연결 시) */}

				<Route path="/influencerIntro" element={<InfluencerIntro />} /> { /* 인플루언서 튜토리얼 */}
				<Route path="/influencer" element={<Influencer />} /> { /* 인플루언서 목록 (미참여) */}
				<Route path="/influencerProfile" element={<InfluencerProfile />} /> { /* 인플루언서 프로필 입력 */}
				<Route path="/profileModify" element={<ProfileModify />} /> { /* 인플루언서 프로필 수정 */}
				<Route path="/participate" element={<Participate />} /> { /* 인플루언서 참여 */}
				<Route path="/participateStop" element={<ParticipateStop />} /> { /* 인플루언서 정지계정 */}
				<Route path="/influencerMy" element={<InfluencerMy />} /> { /* 인플루언서 홈 MY */}
				<Route path="/influencerDetail" element={<InfluencerDetail />} /> { /* 인플루언서 상세 */}
				<Route path="/influencerResign" element={<InfluencerResign />} /> { /* 인플루언서 철회 */}
				<Route path="/InfluencerOthers" element={<InfluencerOthers />} /> { /* 인플루언서 홈 타인 */}
				<Route path="/InfluencerOthersDetail" element={<InfluencerOthersDetail />} /> { /* 인플루언서 타인 상세 */}

				<Route path="/dataIntro" element={<DataIntro />} /> { /* 데이터증명서 인트로 */}
				<Route path="/dataNoneIntro" element={<DataNoneIntro />} /> { /* 데이터증명서 미연동 인트로 */}
				<Route path="/dataList" element={<DataList />} /> { /* 데이터증명서 목록 */}
				<Route path="/dataSelect" element={<DataSelect />} /> { /* 공유데이터 선택 */}
				<Route path="/dataDetail" element={<DataDetail />} /> { /* 증명서 공유하기 데이터 상세 */}
				<Route path="/dataDetailOthers" element={<DataDetailOthers />} /> { /* 데이터 상세 타인 */}
				<Route path="/dataPwSetting" element={<DataPwSetting />} /> { /* 데이터증명서 비밀번호 설정 */}
				<Route path="/dataPw" element={<DataPw />} /> { /* 데이터증명서 비밀번호 입력 */}
				<Route path="/dataPwTimeOut" element={<DataPwTimeOut />} /> { /* 데이터증명서 비밀번호 시간초과 */}
				<Route path="/dataPwError" element={<DataPwError />} /> { /* 데이터증명서 비밀번호 에러 */}

				<Route path="/carIntro" element={<CarIntro />} /> { /* 차량조회 인트로 */}
				<Route path="/car" element={<Car />} /> { /* 차량조회 */}
				<Route path="/carMy" element={<CarMy />} /> { /* 차량조회 결과 */}
				<Route path="/carDetail1" element={<CarDetail1 />} /> { /* 차량조회 차량 상세1 */}
				<Route path="/carDetail2" element={<CarDetail2 />} /> { /* 차량조회 차량 상세2 */}
				<Route path="/carRepair" element={<CarRepair />} /> { /* 차량조회 수리 정비 내역 */}
				<Route path="/carAccident" element={<CarAccident />} /> { /* 차량조회 사고이력 */}
				
				{/* <Route path="/" element={<Home />} /> */}
				<Route path="/" element={<Main />} />
				<Route path="*" element={<NotFound />} />
			</Routes>
		</>
	)
}

export default Index